export default __webpack_public_path__ + "static/media/economy_news.2033cadd.svg";